module.exports = __webpack_public_path__ + "img/four-six.0d97ac14.png";